// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"460":"4e39e1dfd8","570":"421a78d011"}[chunkId] + ".css";
};